
function initMobileSwiper(selector) {
  if (window.innerWidth < 825) {
    // Destroy existing swiper instance if already initialized
    console.log(selector, "selectore");
    if (document.querySelector(`${selector}`)) return;

    
      new Swiper(`${selector}`, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: `${selector} .swiper-pagination`,
          clickable: true,
        },
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`,
        },
      });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (typeof ModalDialog === "undefined") {
    console.error("ModalDialog is not loaded yet!");
    return;
  }

  if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        document.querySelectorAll(".drawer").forEach((drawer) => {
          drawer.style.display = "none";
          drawer.style.visibility = "hidden";
        });
        // document.querySelector(".drawer__close").click();
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        // opener.querySelector('.loading__spinner').classList.remove('hidden');
        const productUrl = opener.getAttribute("data-product-url");
        const variantId = opener.getAttribute("data-variant-id");

        const currentPathname = window.location.pathname;
        const localePathMatch = currentPathname.match(/^\/(\w{2}(?:-\w{2})?)\//);
        let localePrefix = '';

        if (localePathMatch && window.Shopify && window.Shopify.locale && localePathMatch[1] === window.Shopify.locale) {
          localePrefix = `/${localePathMatch[1]}`;
        }

        // let url = `${localePrefix}${productUrl}`;
        let url = productUrl.startsWith(localePrefix) ? productUrl: `${localePrefix}${productUrl}`;

        if (variantId) {
        url = `${url}${url.includes('?') ? '&' : '?'}variant=${variantId}`;
        }

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const productElement = responseHTML.querySelector("product-info");

            this.preprocessHTML(productElement);
            HTMLUpdateUtility?.setInnerHTML(
              this.modalContent,
              productElement?.outerHTML
            );
            

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            const modal = document.querySelector(".quick-add-modal[open]");
            console.log(modal, "Sdfsdfsdfsdfdsfsdf");
            const elswiper = modal.querySelector(".swiper.mobile-only");
              console.log("quicka ddd modal is this");
            const idSelector = `#${elswiper.id}`;
            console.log(idSelector, "id selectore");
              initMobileSwiper(idSelector);

            if (document.body.classList.contains("template-cart") && modal) {
              modal
                .querySelectorAll(".product__view-details")
                .forEach((btn) => btn.remove());
            }

            const el = document.querySelector(
              ".product-form__quantity-and-buy-buttons"
            );


             const sizeGuideProduct = modal.querySelector(".size-guide-product");
            const sizeGuideQuickView = modal.querySelector(
              ".size-guide-quick-view"
            );
            console.log(modal);

            const sizeGuidedata = modal.querySelector(
              ".quick-view-product-popup-modal"
            );
            console.log(sizeGuidedata, "side zuide data");

            const newModal = document.querySelector(`#${modal.id}-sizeguide`);
            console.log(newModal, "new modal is ");
            if (newModal) {
              newModal.innerHTML = sizeGuidedata.innerHTML;
             
           
             
            }

            // hide one of them based on modal ID or condition

            if (sizeGuideProduct)
              sizeGuideProduct.setAttribute(
                "style",
                "display: none !important;"
              );

            if (sizeGuideQuickView)
              sizeGuideQuickView.setAttribute(
                "style",
                "display: block !important;"
              );
              
          if (modal && modal.classList.contains("quick-update-btn")) {
            console.log("Modal has the class!");
          } else {
            if (el) {
              const style = window.getComputedStyle(el);
              if (style.display != "none") {
                const allRadioInputs = modal.querySelectorAll(
                  '.size-picker input[type="radio"]'
                );
                allRadioInputs.forEach((input) => {
                  if (input.hasAttribute("checked")) {
                    input.removeAttribute("checked");
                    console.log(`Removed checked from`, input);
                      document.querySelectorAll('#selected-size').forEach((span) => {
                      span.style.display = 'none';
                    });
                  }
                });
                 const allRadioInputsleng = modal.querySelectorAll(
                    '.length-picker input[type="radio"]'
                  );
                  allRadioInputsleng.forEach((input) => {
                    if (input.hasAttribute("checked")) {
                      input.removeAttribute("checked");
                      console.log(`Removed checked from`, input);
                       document.querySelectorAll('#selected-length').forEach((span) => {
                      span.style.display = 'none';
                    });
                    }
                  });
              }
            }
          }
            // opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
      updateSwatchImageHandlers(productElement) {
        const swatches = productElement.querySelectorAll(
          "[data-option-index][data-variant-id]"
        );
        const featuredImage = productElement.querySelector(
          ".product__media img, .product__media video"
        );

        if (!swatches.length || !featuredImage) return;

        swatches.forEach((swatch) => {
          swatch.addEventListener("click", () => {
            const variantImage = swatch.getAttribute("data-media-id");
            if (!variantImage) return;

            // Find the media element with matching data-media-id
            const newMedia = productElement.querySelector(
              `[data-media-id="${variantImage}"]`
            );
            

            if (newMedia) {
              // Replace featured image src
              if (newMedia.tagName.toLowerCase() === "img") {
                featuredImage.setAttribute("src", newMedia.getAttribute("src"));
              } else if (newMedia.tagName.toLowerCase() === "video") {
                // Optional: handle videos if needed
                featuredImage.replaceWith(newMedia.cloneNode(true));
              }

              // Update active thumbnail state
              productElement
                .querySelectorAll(".product__thumbnail")
                .forEach((thumb) => thumb.classList.remove("active"));

              const thumb = productElement.querySelector(
                `.product__thumbnail[data-media-id="${variantImage}"]`
              );
              if (thumb) thumb.classList.add("active");
            }
            console.log("new media is");
          });
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient")
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      isCartContext() {
        if (document.body.classList.contains("template-cart")) return true;

        const normalizedPath = window.location.pathname
          ? window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?\//, "/")
          : "";

        return (
          normalizedPath === "/cart" || normalizedPath.startsWith("/cart/")
        );
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        const wishlistButton = productElement.querySelector(".wishlist-btn");
        if (wishlistButton) wishlistButton.remove();

        if (this.isCartContext()) {
          productElement
            .querySelectorAll(".product__view-details")
            .forEach((link) => link.remove());
        }
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId)
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        const desktopColumns = product?.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }
    }
  );
}
});



document.addEventListener("DOMContentLoaded", () => {
  // When modal opens, bind thumbnail click events
  document.body.addEventListener("click", (e) => {
    const thumbnail = e.target.closest(
      ".quick-add-modal [id^='ThumbnailList-'] .thumbnail-list__item"
    );

    if (!thumbnail) return; // not a thumbnail click

    const mediaId = thumbnail.getAttribute("data-media-id");

    // Find the nearest modal wrapper
    const modal = thumbnail.closest(".quick-add-modal");
    if (!modal) return;

    // Find the related gallery inside this modal
    const gallery = modal.querySelector("[id^='Slider-Gallery-']");
    if (!gallery) return;

    const galleryItem = gallery.querySelector(`[data-media-id$="${mediaId}"]`);
    if (!galleryItem) return;

    // Remove active class from all items
    gallery.querySelectorAll(".product__media-item").forEach((item) => {
      item.classList.remove("is-active");
    });

    // Move the clicked gallery item to first position
    gallery.prepend(galleryItem);

    // Mark it active
    galleryItem.classList.add("is-active");

    // --- Handle Thumbnails ---
    const allThumbnails = modal.querySelectorAll(
      "[id^='ThumbnailList-'] .thumbnail-list__item"
    );
    allThumbnails.forEach((item) => item.classList.remove("is-active"));

    thumbnail.classList.add("is-active");
  });
});

// Use IIFE to avoid duplicate declaration errors
(function() {
  const quickAddModal = document.querySelector(".quick-add-modal");

  if (quickAddModal) {
    quickAddModal.addEventListener("toggle", function () {
      if (quickAddModal.open) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    });
  }
})();

function updateArrowState(list, prevBtn, nextBtn) {
  prevBtn.disabled = list.scrollTop === 0;
  nextBtn.disabled = list.scrollTop + list.clientHeight >= list.scrollHeight;
}

// document.addEventListener("DOMContentLoaded", function () {
//   function initThumbnailScroll(modal) {
//     console.log("modalopen working");
//     if (modal.dataset.thumbInit === "true") return; // avoid double-init
//     const list = modal.querySelector(".thumbnail-list");
//     const prevBtn = modal.querySelector(".slider-previous");
//     const nextBtn = modal.querySelector(".slider-next");
//     if (!list || !prevBtn || !nextBtn) return;
//     modal.dataset.thumbInit = "true";

//     console.log("SDfsdfdsfdsfdf");

//     // compute a sensible scroll step (fallback to 100)
//     const item = list.querySelector(".thumbnail-list__item");
//     const itemHeight = item ? item.offsetHeight : 100;
//     const scrollStep = itemHeight * 3; // scroll 3 items at a time (adjust)

//     function updateArrowState() {
//       prevBtn.disabled = list.scrollTop <= 0;
//       nextBtn.disabled =
//         list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
//     }

//     prevBtn.addEventListener("click", function (e) {
//       e.preventDefault();
//       list.scrollBy({ top: -scrollStep, behavior: "smooth" });
//     });

//     nextBtn.addEventListener("click", function (e) {
//       e.preventDefault();
//       list.scrollBy({ top: scrollStep, behavior: "smooth" });
//     });

//     list.addEventListener("scroll", updateArrowState);
//     // initial state (short timeout to allow layout)
//     setTimeout(updateArrowState, 50);
//   }

//   // observe modals for open attr changes
//   const observer = new MutationObserver(function (mutations) {
//     mutations.forEach(function (m) {
//       if (m.type === "attributes" && m.attributeName === "open") {
//         const modal = m.target;
//         if (modal.hasAttribute("open")) initThumbnailScroll(modal);
//       }
//     });
//   });

//   document.querySelectorAll(".quick-add-modal").forEach(function (modal) {
//     observer.observe(modal, { attributes: true });
//     // initialize immediately if already open
//     console.log("modalopen");
//     if (modal.hasAttribute("open")) initThumbnailScroll(modal);
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (e) {
    const modal = e.target.closest(".quick-add-modal[open]");
    if (!modal) return;
    const nextBtn = e.target.closest(".slider-next");

    const list = modal.querySelector(".thumbnail-list");
    if (!list) return;

      modal.querySelectorAll("details").forEach((details) => {
      const summary = details.querySelector("summary");
      if (!summary) return;

      summary.addEventListener("click", function () {
        const currentDetails = this.parentElement;

        // Close all other details inside this modal
        modal.querySelectorAll("details").forEach((d) => {
          if (d !== currentDetails) {
            d.removeAttribute("open");
            const s = d.querySelector("summary");
            if (s) s.setAttribute("aria-expanded", "false");
          }
        });

        // Update aria-expanded for clicked summary after toggle
        setTimeout(() => {
          const isOpen = currentDetails.hasAttribute("open");
          this.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }, 0);
      });
    });
    const scrollStep = 400;

    // helper to update button states
    function updateArrows() {
      if (list.scrollTop <= 0) {
        modal
          .querySelector(".slider-previous")
          ?.classList.add("slick-disabled");
      } else {
        modal
          .querySelector(".slider-previous")
          ?.classList.remove("slick-disabled");
      }

      if (list.scrollTop + list.clientHeight >= list.scrollHeight) {
        modal.querySelector(".slider-next")?.classList.add("slick-disabled");
      } else {
        modal.querySelector(".slider-next")?.classList.remove("slick-disabled");
      }
    }

    if (modal && nextBtn) {
      console.log("✅ NEXT arrow clicked inside open modal");

      list.scrollBy({ top: scrollStep, behavior: "smooth" });
      setTimeout(updateArrows, 400); // wait for smooth scroll
    }
    const previousBtn = e.target.closest(".slider-previous");
    if (modal && previousBtn) {
      list.scrollBy({ top: -scrollStep, behavior: "smooth" });
      console.log("✅ PREVious arrow clicked inside open modal");
      setTimeout(updateArrows, 400);
    }
  });
});



console.log("quick add modla js file");

function initSizeGuide(modalElement) {
    if (!modalElement) return;

    // --- Scoped search inside the modal ---
    const productInfoDiv = modalElement.querySelector('#product-info');
    if (!productInfoDiv) return;

    const jsonString = productInfoDiv.dataset.json;
    const productData = JSON.parse(jsonString);

    const container = modalElement.querySelector('#size-guide-container');
    const regionSelect = modalElement.querySelector('#sizepanel-region');
    const regionDropdownWrapper = modalElement.querySelector('#region-dropdown-wrapper');

    let currentUnit = 'cm';
    let currentRegion = 'usa';
    const regionalKeys = ['usa', 'eu', 'uk'];
    let hasRegionalData = false;

    // --- Check if product has regional data ---
    if (
        productData &&
        productData.length > 0 &&
        productData[0].table &&
        productData[0].table.headers
    ) {
        const headers = productData[0].table.headers;
        hasRegionalData = headers.some((header) =>
            regionalKeys.includes(header.key.toLowerCase())
        );
    }

    // --- Handle dropdown visibility dynamically ---
    if (regionDropdownWrapper) {
        if (hasRegionalData) {
            regionDropdownWrapper.style.display = 'block';
            regionDropdownWrapper.style.flex = '0 0 auto';
        } else {
            regionDropdownWrapper.style.display = 'none';
            const measurementToggle = modalElement.querySelector('.measurement-toggle');
            console.log(measurementToggle, "mes toggle");
            if (measurementToggle) {
                measurementToggle.style.marginLeft = 'auto';
                measurementToggle.style.justifySelf = 'flex-end';
                measurementToggle.style.flexShrink = '0';
            }
        }
    }

    // --- Render function ---
    function renderTables(unit, region) {
        if (!container) return;
        container.innerHTML = '';

        productData.forEach((guide) => {
  let html = `
    <h3 class="size-tables__title">${guide.name}</h3>
    <p class="size-tables__description">${guide.description}</p>
    <div class="size-tables-data">
      <table class="size-tables__table" cellspacing="0">
        <thead>
          <tr class="size-tables__row alt-background-color">
            ${guide.table.headers
              .filter((h) => {
                if (h.key === 'type') return true;
                if (/(_in|_cm)$/.test(h.key)) {
                  return h.key.endsWith(`_${unit}`);
                }
                if (hasRegionalData) {
                  return regionalKeys.includes(h.key.toLowerCase())
                    ? h.key.toLowerCase() === region.toLowerCase()
                    : false;
                }
                return !regionalKeys.includes(h.key.toLowerCase());
              })
              .map((h) => `<th class="size-tables__cell size-guide__primary-column">${h.label}</th>`)
              .join('')}
          </tr>
        </thead>
        <tbody>
          ${guide.table.rows
            .map(
              (row) => `
                <tr>
                  ${guide.table.headers
                    .filter((h) => {
                      if (h.key === 'type') return true;
                      if (/(_in|_cm)$/.test(h.key)) {
                        return h.key.endsWith(`_${unit}`);
                      }
                      if (hasRegionalData) {
                        return regionalKeys.includes(h.key.toLowerCase())
                          ? h.key.toLowerCase() === region.toLowerCase()
                          : false;
                      }
                      return !regionalKeys.includes(h.key.toLowerCase());
                    })
                    .map((h) => `<td class="size-tables__cell size-guide__primary-column">${row[h.key] || ''}</td>`)
                    .join('')}
                </tr>
              `
            )
            .join('')}
        </tbody>
      </table>
    </div>
  `;
  container.innerHTML += html;
});


      
    }

    // --- Initial render ---
    renderTables(currentUnit, currentRegion);


 
    const toggleBlocks = modalElement.querySelectorAll('.toggle-block');


    console.log(toggleBlocks, "toggleblocks");
    toggleBlocks.forEach((block) => {
        block.addEventListener('click', () => {
          console.log("onclick");
            // Find the radio input inside this block
            const radio = block.querySelector('input.toggle-radio');
            if (!radio) return;

            // Set this radio as checked
            radio.checked = true;

            // Optional: remove active styling from others
            toggleBlocks.forEach((b) => b.classList.remove('active'));
            block.classList.add('active');

            // Update current unit & re-render size guide
            currentUnit = radio.value; // "in" or "cm"
            renderTables(currentUnit, currentRegion);

            console.log('✅ Measurement changed to:', currentUnit);
        });
    });



    // --- Measurement toggle ---
    modalElement
        .querySelectorAll('input[name="sizepanel-measurement"]')
        .forEach((radio) => {
            radio.addEventListener('change', (e) => {
              console.log("on change of size measurement");
                currentUnit = e.target.value;
                renderTables(currentUnit, currentRegion);
            });
        });

    // --- Region change ---
    if (regionSelect) {
        regionSelect.addEventListener('change', (e) => {
            currentRegion = e.target.value;
            renderTables(currentUnit, currentRegion);
        });
    }

}


   function handleOnClickSizeGuide() {
    const modal = document.querySelector('.quick-add-modal[open]');
    if (modal) {
        console.log("modal", modal);
        console.log('Modal ID:', modal.id);
        console.log(`${modal.id}-sizeguide`);
        const newModal = document.querySelector(`#${modal.id}-sizeguide`);
        console.log(newModal);

        if (newModal) {
            const defaultRadio = newModal.querySelector(`[id="measurement-cm"]`);

            if (defaultRadio) {
                defaultRadio.checked = true;
            }
            const tabs = newModal.querySelectorAll('.tabs-nav li');
            const panes = newModal.querySelectorAll('.tab-pane');

            tabs.forEach((tab) => {
                tab.addEventListener('click', function() {
                    const target = this.getAttribute('data-tab');
                    console.log(target, "target button");
                    tabs.forEach((t) => t.classList.remove('active'));
                    panes.forEach((p) => p.classList.remove('active'));

                    this.classList.add('active');
                    const targetPane = newModal.querySelector(`[id="${target}"]`);

                    if (targetPane) {
                        targetPane.classList.add('active');
                    }
                });
            });

            newModal.classList.remove('hidden');

            newModal.style.opacity = '1';
            newModal.style.visibility = 'visible';
            newModal.style.zIndex = '9999999999';
            const content = newModal.querySelector('.product-popup-modal_sizeguide__content');
            if (content) {
                content.classList.remove('hidden');
            }

            const closeBtn = newModal.querySelector('#ModalClose-popup_size_guide');
            if (closeBtn) {
                closeBtn.addEventListener('click', function() {
                    newModal.style.opacity = '0';
                    newModal.style.visibility = 'hidden';
                    newModal.style.zIndex = '-1';

                    if (content) {
                        content.classList.add('hidden');
                    }

                    newModal.classList.add('hidden');
                });
            }
            newModal.addEventListener('click', function(e) {
                if (e.target === newModal) {
                    newModal.style.opacity = '0';
                    newModal.style.visibility = 'hidden';
                    newModal.style.zIndex = '-1';

                    if (content) {
                        content.classList.add('hidden');
                    }

                    newModal.classList.add('hidden');
                }
            });
            initSizeGuide(newModal);
        } else {
            console.log("not found");
            if (
                window.location.href.includes('/collections/') ||
                window.location.href.includes('/my-list') || 
                window.location.href.includes('/search') || 
                window.location.href.includes('/products')
            ) {
                const newModal = document.querySelector(`#QuickAdd-collection-page-sizeguide`);
                console.log(newModal);
                if (newModal) {
                    const sizeModal = modal.querySelector('#quick-view-ProductPopup-popup_size_guide');
                    console.log(sizeModal);

                    newModal.innerHTML = sizeModal.innerHTML;

                    const defaultRadio = newModal.querySelector(`[id="measurement-cm"]`);

                    if (defaultRadio) {
                        defaultRadio.checked = true;
                    }
                    const tabs = newModal.querySelectorAll('.tabs-nav li');
                    const panes = newModal.querySelectorAll('.tab-pane');

                    tabs.forEach((tab) => {
                        tab.addEventListener('click', function() {
                            const target = this.getAttribute('data-tab');
                            console.log(target);
                            tabs.forEach((t) => t.classList.remove('active'));
                            panes.forEach((p) => p.classList.remove('active'));

                            this.classList.add('active');
                            const targetPane = newModal.querySelector(`[id="${target}"]`);

                            if (targetPane) {
                                targetPane.classList.add('active');
                            }
                        });
                    });

                    newModal.classList.remove('hidden');

                    newModal.style.opacity = '1';
                    newModal.style.visibility = 'visible';
                    newModal.style.zIndex = '9999999999';
                    const content = newModal.querySelector('.product-popup-modal_sizeguide__content');
                    if (content) {
                        content.classList.remove('hidden');
                    }

                    const closeBtn = newModal.querySelector('#ModalClose-popup_size_guide');
                    if (closeBtn) {
                        closeBtn.addEventListener('click', function() {
                            newModal.style.opacity = '0';
                            newModal.style.visibility = 'hidden';
                            newModal.style.zIndex = '-1';

                            if (content) {
                                content.classList.add('hidden');
                            }

                            newModal.classList.add('hidden');
                        });
                    }
                    newModal.addEventListener('click', function(e) {
                        if (e.target === newModal) {
                            newModal.style.opacity = '0';
                            newModal.style.visibility = 'hidden';
                            newModal.style.zIndex = '-1';

                            if (content) {
                                content.classList.add('hidden');
                            }

                            newModal.classList.add('hidden');
                        }
                    });
                    initSizeGuide(newModal);
                }
            }
        }
    }
}